/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type Store from '@ember-data/store';
import StandardizedPlatform from 'embercom/objects/standalone/platforms/standardized-platform';

export const CONVERSATION_CUSTOM_ATTRIBUTE_PREFIX = 'conversation.custom_attribute.';
export const COMPANY_CUSTOM_DATA_PREFIX = 'company.custom_data.';
export const CUSTOM_DATA_PREFIX = 'custom_data.';

export function getValidatedPlatform(
  appService: AppService,
  finStandaloneService: FinStandaloneService,
): StandardizedPlatform | null {
  if (!appService.app.canUseStandaloneMultiEnv) {
    return null;
  }

  let platform = finStandaloneService.platform;
  if (!platform || !(platform instanceof StandardizedPlatform)) {
    return null;
  }

  if (platform.isLoadingDataFields) {
    return null;
  }

  return platform;
}

export function isFieldUnavailableInProduction(
  identifier: string,
  platform: StandardizedPlatform,
  store: Store,
): boolean {
  if (identifier.startsWith(CONVERSATION_CUSTOM_ATTRIBUTE_PREFIX)) {
    let descriptorId = identifier.split('.')[2];
    if (!descriptorId) {
      return false;
    }
    let descriptor = store.peekRecord('conversation-attributes/descriptor', descriptorId);
    if (!descriptor || !descriptor.isStandaloneSyncedAttribute || descriptor.archived) {
      return false;
    }
    return !platform.isMappedConversationAttribute(identifier);
  } else if (identifier.startsWith(COMPANY_CUSTOM_DATA_PREFIX)) {
    return !platform.isMappedCompanyAttribute(identifier);
  } else if (identifier.startsWith(CUSTOM_DATA_PREFIX)) {
    return !platform.isMappedUserAttribute(identifier);
  }

  return false;
}
